import React from 'react';
import ReactDOM from 'react-dom';
import 'normalize.css';
import './common.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

// imports to run redux
// import createStore from 'redux';
// import { Provider } from 'react-redux';
// import { reducer } from './redux/reducers/index';

// const store  = createStore(reducer);

import { Provider } from 'react-redux';
import store from './redux/store';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App/>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
